import { getDataUrlImageType } from './file-utils';

const JPEG_TYPE = 'image/jpeg';
const JPEG_QUALITY = 0.92;
const CONVERTIBLE_TYPES = new Set(['image/avif', 'image/webp']);

const loadImage = (dataUrl: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Could not decode image'));
    image.src = dataUrl;
  });

const drawToJpeg = (image: HTMLImageElement): string => {
  const canvas = document.createElement('canvas');
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  canvas.getContext('2d')?.drawImage(image, 0, 0);
  return canvas.toDataURL(JPEG_TYPE, JPEG_QUALITY);
};

/**
 * Pictures synced to the device may be AVIF, but originals stay JPEG on the server.
 * Anything that sends a device picture back to the server goes through here: AVIF/WebP data URLs are re-encoded to JPEG,
 * every other value (JPEG, PNG, placeholders) is returned untouched.
 */
export const toJpegDataUrl = async (dataUrl: string): Promise<string> => {
  if (!dataUrl?.startsWith('data:') || !CONVERTIBLE_TYPES.has(getDataUrlImageType(dataUrl))) {
    return dataUrl;
  }
  return drawToJpeg(await loadImage(dataUrl));
};
